<template>
  <div class="forData">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="150px"
      class="demo-ruleForm forDataLint"
    >
      <el-form-item :label="dataobjsend.shexiangtoumingcheng" prop="name" style="width:45%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjsend.shebeixuliehao" prop="deviceserial" style="width:45%">
        <el-input v-model="ruleForm.deviceserial"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjsend.shebeiyanzhengma" prop="validatecode" style="width:45%">
        <el-input v-model="ruleForm.validatecode"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjsend.luzhikaiguan" prop="enable" style="width:45%">
        <!-- <el-input v-model="ruleForm.enable"></el-input> -->
        <el-select v-model="ruleForm.enable" placeholder="请选择" style="width:100%">
          <el-option
            v-for="item in optionsenable"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item :label="dataobjsend.buchenfangzhuangtai" prop="isdefence" style="width:45%">
        <el-select v-model="ruleForm.isdefence" placeholder="请选择" style="width:100%">
          <el-option
            v-for="item in optionIsdefence"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>-->

      <!-- <el-form-item :label="dataobjsend.shexiangtouleixing" prop="type" style="width:45%">
        <el-select v-model="ruleForm.type" placeholder="请选择" style="width:100%">
          <el-option
            v-for="item in optionType"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>-->

      <el-form-item :label="dataobjsend.dingshizhuapai" prop="captureflag" style="width:45%">
        <!-- <el-input v-model="ruleForm.captureflag"></el-input> -->
        <el-select v-model="ruleForm.captureflag" placeholder="请选择" style="width:100%">
          <el-option
            v-for="item in optionCaptureflag"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="dataobjsend.zhuapaizhouqi" prop="capturetime" style="width:45%">
        <el-input v-model="ruleForm.capturetime"></el-input>
      </el-form-item>
      <el-form-item :label="dataobjsend.shifouzaixian" prop="status" style="width:45%">
        <!-- <el-input v-model="ruleForm.status"></el-input> -->
        <el-select v-model="ruleForm.status" placeholder="请选择" style="width:100%">
          <el-option
            v-for="item in optionStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="dataobjsend.shangxianshijian" style="width:45%" prop="onlinetime">
        <!-- <el-input v-model="ruleForm.onlinetime"></el-input> -->
        <el-date-picker
          v-model="ruleForm.onlinetime"
          type="date"
          placeholder="选择日期"
          format="yyyy 年 MM 月 dd 日"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
      </el-form-item>
      <el-form-item :label="dataobjsend.beizhu" style="width:45%">
        <el-input v-model="ruleForm.remark"></el-input>
      </el-form-item>
    </el-form>
    <div class="btenEtiel">
      <span slot="footer" class="dialog-footer list">
        <el-button @click="handhideNo()">{{dataobjsend.quxiao}}</el-button>
        <el-button type="primary" @click="releaseHand">{{dataobjsend.queding}}</el-button>
      </span>
    </div>
  </div>
</template>

<script>
import { Add_Camers } from "@/network/lineRequest";
export default {
  props: {
    dataobjsend: {
      type: Object,
      default: {},
    },
    ruleForm: {
      type: Object,
      default: {},
    },
    hideClone: {
      type: Function,
      default: Function,
    },
  },
  data() {
    const numberRule = (rule, value, callback) => {
      console.log(value >= 10);

      if (Number(value) >= 10) {
        callback();
      } else {
        callback(new Error("抓拍周期不能小于等于10"));
      }
    };
    return {
      rules: {
        name: [
          { required: true, message: "请输入摄像头名称", trigger: "blur" },
        ],
        deviceserial: [
          { required: true, message: "请输入设备序列号", trigger: "blur" },
        ],
        validatecode: [
          { required: true, message: "请输入设备验证码", trigger: "blur" },
        ],
        enable: [
          { required: true, message: "请选择录制开关", trigger: "change" },
        ],
        // isdefence: [
        //   { required: true, message: "请选择布撤防状态", trigger: "change" },
        // ],
        // type: [
        //   { required: true, message: "请选择摄像头类型", trigger: "change" },
        // ],
        captureflag: [
          { required: true, message: "是否抓拍", trigger: "change" },
        ],
        capturetime: [
          {
            required: true,
            message: "请输入抓拍周期",
            trigger: "blur",
          },
          {
            validator: numberRule,
            trigger: "blur",
          },
        ],
        status: [{ required: true, message: "是否在线", trigger: "change" }],
      },
      lang_file: sessionStorage.getItem("lang_file"),
      optionsenable: [],
      optionIsdefence: [],
      optionCaptureflag: [],
      optionStatus: [],

      optionType: [],
    };
  },
  created() {},
  mounted() {
    this.handFendZun()
  },
  methods: {
    // 翻译
    handFendZun() {
      this.optionsenable.push(
        {
          value: "0",
          label: this.lang_file == "zh-cn" ? "关闭" : "close",
        },
        {
          value: "1",
          label: this.lang_file == "zh-cn" ? "开启" : "open",
        }
      );
      this.optionCaptureflag.push(
        {
          value: "0",
          label: this.lang_file == "zh-cn" ? "否" : "no",
        },
        {
          value: "1",
          label: this.lang_file == "zh-cn" ? "是" : "yes",
        }
      );
      this.optionIsdefence.push(
        {
          value: "0",
          label: this.lang_file == "zh-cn" ? "撤防" : "Withdraw",
        },
        {
          value: "1",
          label: this.lang_file == "zh-cn" ? "布防" : "No defense",
        }
      );
      this.optionStatus.push(
        {
          value: "0",
          label: this.lang_file == "zh-cn" ? "不在线" : "Not online",
        },
        {
          value: "1",
          label: this.lang_file == "zh-cn" ? "在线" : "on-line",
        }
      );
      this.optionType.push(
        {
          value: "1",
          label: this.lang_file == "zh-cn" ? "萤石云" : "Fluorite cloud",
        },
        {
          value: "2",
          label: this.lang_file == "zh-cn" ? "海康" : "Haikang",
        }
      );
    },
    handhideNo() {
      this.cloneRed();
      this.hideClone();
    },
    releaseHand() {
      this.$refs.ruleForm.validate(async (valid) => {
        console.log("1222");

        if (valid) {
          //摄像头序号字母转换大写
          this.ruleForm.deviceserial = this.ruleForm.deviceserial.toUpperCase();

          const { code, data, msg } = await Add_Camers(this.ruleForm);
          console.log(msg);
          if (code) {
            this.hideClone();
            this.$emit("arend_sup", this.ruleForm.area_uuid);
            this.cloneRed();
          } else {
            this.$message.error(msg);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 清空输入框
    cloneRed() {
      console.log("222");

      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>

<style scoped lang="less">
.forDataLint {
  display: flex;
  flex-wrap: wrap;
}
.list {
  display: flex;
  justify-content: center;
}
</style>
